import { render, staticRenderFns } from "./topHeader.vue?vue&type=template&id=284a1f9d&scoped=true"
import script from "./topHeader.vue?vue&type=script&lang=js"
export * from "./topHeader.vue?vue&type=script&lang=js"
import style0 from "./topHeader.vue?vue&type=style&index=0&id=284a1f9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a1f9d",
  null
  
)

export default component.exports